export default __webpack_public_path__ + "static/media/icon-dishwasher.d646d7f6.svg";